import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import Icon from 'components/patterns/Icon'
import { Dropdown, Menu } from 'antd'
import strings from 'utils/strings'
import withStyle from './NestedDropDown.style.js'

const NestedDropDown = ({ list, display, placement }) => {
  const [expanded, setExpanded] = useState(false)

  if (!list || list.length === 0) return display

  const menu = (
    <Menu>
      {list.map((item) => {
        if (!item) {
          return <div />
        }
        const { uri, display, children } = item
        return children && children.length > 0 ? (
          <Menu.SubMenu
            key={uri || display}
            title={
              <span>
                {uri ? (
                  <Link to={uri} target="_blank">
                    {display}
                  </Link>
                ) : (
                  display
                )}
                <span className="nestedDropdownSpan">
                  {strings.shared_with}
                </span>
              </span>
            }
          >
            {children.map(({ display, uri }) => (
              <Menu.Item key={uri || display}>
                {uri ? (
                  <Link to={uri} target="_blank">
                    {display}
                  </Link>
                ) : (
                  display
                )}
              </Menu.Item>
            ))}
          </Menu.SubMenu>
        ) : (
          <Menu.Item key={uri || display}>
            {uri ? <Link to={uri}>{display}</Link> : display}
          </Menu.Item>
        )
      })}
    </Menu>
  )

  return (
    <Dropdown
      placement={placement}
      trigger={['hover']}
      onVisibleChange={() => setExpanded(!expanded)}
      onBlur={() => setExpanded(!expanded)}
      overlay={menu}
    >
      <span className="ant-dropdown-link">
        <span className="nestedAntDropdownLink">{display}</span>
        {list.length > 0 && (
          <Icon icon={expanded ? 'FaChevronUp' : 'FaChevronDown'} />
        )}
      </span>
    </Dropdown>
  )
}

NestedDropDown.defaultProps = {
  list: [],
  placement: 'bottomRight',
}

NestedDropDown.propTypes = {
  list: PropTypes.array,
  display: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  placement: PropTypes.oneOf([
    'topLeft',
    'topCenter',
    'topRight',
    'bottomLeft',
    'bottomCenter',
    'bottomRight',
  ]),
}

export default withStyle(NestedDropDown)
